
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 2c1.381 0 2.533.97 2.875 2.25.351-.146.724-.25 1.125-.25 1.645 0 3 1.355 3 3v1.188A2.925 2.925 0 0124 8c1.645 0 3 1.355 3 3v12c0 3.854-3.146 7-7 7h-4.625c-1.919 0-3.543-.923-4.719-2.094l-6.781-6.781c-1.163-1.163-1.163-3.087 0-4.25s3.087-1.163 4.25 0L9 17.75V7c0-1.645 1.355-3 3-3 .401 0 .774.104 1.125.25C13.467 2.97 14.619 2 16 2zm0 2c-.565 0-1 .435-1 1v10h-2V7c0-.565-.435-1-1-1s-1 .435-1 1v15.594l-1.719-1.719-2.563-2.594c-.399-.399-1.039-.399-1.438 0s-.399 1.039 0 1.438l6.813 6.75c.913.909 2.009 1.531 3.281 1.531h4.625c2.774 0 5-2.226 5-5V11c0-.565-.435-1-1-1s-1 .435-1 1v4h-2V7c0-.565-.435-1-1-1s-1 .435-1 1v8h-2V5c0-.565-.435-1-1-1z"}})])
          )
        }
      }
    